<mat-tab-group>
  
  <mat-tab label="Pesquisar" >
    <p class="txt">Selecione a indústria para importação em lote:</p>
    <div class="search-box">
      <select>
        <option>BUSCA POR CNPJ</option>
      </select>
      <input
        #inputValue
        placeholder="01.234.567/0001-00"
        [(ngModel)]="fiscalNumber"
        (keypress)="onPressEnterSearchCompany($event)"
        [textMask]="{
          mask: fiscalNumberMask,
          guide: false,
          keepCharPositions: true
        }" />
      <div class="search-icon-container" (click)="findIndustry(inputValue.value)">
        <mat-icon aria-hidden="false">search</mat-icon>
      </div>
    </div>

    <div class="company-card" *ngIf="hasCompany()">
      <div class="company-logo">
        <img src="./assets/icons/no-logo-company-icon.svg" />
      </div>
      <div class="company-data">
        <span class="company-name">{{ company.getCorporateName() }} </span>
        <span class="company-cnpj">CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }}</span>
      </div>
    </div>
    <p class="txt" *ngIf="searchActionFired && searchNotFound">Nenhum resultado encontrado.</p>
    <hr *ngIf="searchActionFired" />

    <div [ngClass]="{ on: hasCompany(), off: !hasCompany() }" class="form-area">
      <div class="file-header">
        <p class="txt">Adicionar vários registros de uma vez.</p>
        <a [href]="fileLink" download>
          <mat-icon class="download-icon" aria-hidden="false">file_download</mat-icon>
          <p class="txt">Faça download do arquivo modelo .csv</p>
        </a>
      </div>
      <div class="file-input">
        <form (ngSubmit)="uploadFile()">
          <label for="file" *ngIf="!fileName">Clique aqui para selecionar o arquivo .CSV</label>
          <label for="file" *ngIf="fileName">{{ fileName }}</label>
          <input type="file" accept=".csv" id="file" files (change)="getFile($event)" />
          <div fxLayoutAlign="end center">
            <button class="add-btn"><mat-icon aria-hidden="false">add_box</mat-icon> ADICIONAR EM LOTE</button>
          </div>
        </form>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
